import { API_BASE_URL, BASE_SERVICE_URL, CUSTOMER_SERVICES } from "@constants/services/apiRoutes";
import { OfficeInfoRequest } from "@customTypes/responses/customer";
import { backendBlobRequest, backendRequest } from "@services/requestService";

export const getTenantLogoInfo = async () => {
  const url = `${API_BASE_URL}${BASE_SERVICE_URL.customer}${CUSTOMER_SERVICES.office}`;

  const response = await backendRequest<OfficeInfoRequest>(url, "GET");
  return response;
};

export const getTenantImage = async (url: string): Promise<string> => {
  const response = await backendBlobRequest(url, "GET");
  return URL.createObjectURL(response);
};
